export default {
  barlow: 'Barlow, Georgia, serif',
  condensed: 'Barlow Condensed, Georgia, serif',
};
